// 3rd party
import * as React from 'react';

// Shared UI
import { useLocalization } from '@shared-ui/localization-context';

// UI Toolkit
import { UitkPrimaryButton } from 'uitk-react-button';

interface TestLinkButtonProps {
  link?: string;
  onSuccess?: () => void;
  onFailure?: () => void;
}

function TestLinkButton({ link, onSuccess, onFailure }: TestLinkButtonProps) {
  const l10n = useLocalization();

  const buttonText = l10n.formatText('common.test_link');

  function handleClick() {
    if (link) {
      window.open(link);

      onSuccess?.();
    } else {
      onFailure?.();
    }
  }

  return <UitkPrimaryButton onClick={handleClick}>{buttonText}</UitkPrimaryButton>;
}

export { TestLinkButton };
